document.addEventListener("DOMContentLoaded", function () {

  const input = document.querySelector(".bookscape-search-input");
  const dropdown = document.querySelector(".bookscape-search-suggestions");
  const list = document.querySelector(".bookscape-suggestion-list");

  if (!input) return;

  let timeout;

  input.addEventListener("input", function () {
    clearTimeout(timeout);

    timeout = setTimeout(function () {
      const query = input.value.trim();

      if (query.length < 2) {
        dropdown.style.display = "none";
        return;
      }

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
        .then(res => res.json())
        .then(data => {
          const products = data.resources.results.products;
          list.innerHTML = "";

          if (!products || products.length === 0) {
            dropdown.style.display = "none";
            return;
          }

          products.forEach(product => {
            const li = document.createElement("li");
            li.textContent = product.title;
            li.onclick = () => window.location.href = product.url;
            list.appendChild(li);
          });

          dropdown.style.display = "block";
        });
    }, 300);
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".bookscape-search-wrapper")) {
      dropdown.style.display = "none";
    }
  });

});
